<template>
  <section class="BasicHeader BasicHeader--default ContentPageHeader">
    <div class="Header-topNav">
      <div class="Header-topNav-inner">
        <div>
          <router-link to="/home">
            <a class="BlueOceanLogo">
              啥都签智能软件服务平台
            </a>
          </router-link>
        </div>
        <div class="u-flex-grow">
          <div style="margin-left: 20px">
            <a-dropdown>
              <a-button-group size="small">
                <a-button icon="global" ghost/>
                <a-button ghost>{{ country }}</a-button>
              </a-button-group>
              <a-menu slot="overlay">
                <a-menu-item key="美国" @click="handleCountry('美国')">美国</a-menu-item>
                <a-menu-item key="英国" @click="handleCountry('英国')">英国</a-menu-item>
                <a-menu-item key="澳大利亚" @click="handleCountry('澳大利亚')">澳大利亚</a-menu-item>
                <!--                <a-menu-item key="墨西哥" @click="handleCountry('墨西哥')">墨西哥</a-menu-item>-->
                <a-menu-item key="泰国" @click="handleCountry('泰国')">泰国</a-menu-item>
                <a-menu-item key="韩国" @click="handleCountry('韩国')">韩国</a-menu-item>
                <a-menu-item key="法国" @click="handleCountry('法国')">法国</a-menu-item>
                <a-menu-item key="加拿大" @click="handleCountry('加拿大')">加拿大</a-menu-item>
                <a-menu-item key="新西兰" @click="handleCountry('新西兰')">新西兰</a-menu-item>
                <a-menu-item key="俄罗斯" @click="handleCountry('俄罗斯')">俄罗斯</a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
        </div>
        <a-menu v-model="current" mode="horizontal" class="ContentPageMenu">
          <template v-for="item in permissionList">
            <a-menu-item v-if="!item.children" :key="item.component">
              <router-link :to="item.url">
                <a-icon :type="item.icon"/>
                {{ item.name }}
              </router-link>
            </a-menu-item>
            <a-sub-menu v-else :key="item.authority">
              <span slot="title" class="submenu-title-wrapper"> <a-icon :type="item.icon"/> {{ item.name }} </span>
              <template v-for="child in item.children">
                <a-menu-item :key="child.component">
                  <router-link :to="child.url">
                    {{ child.name }}
                  </router-link>
                </a-menu-item>
              </template>
            </a-sub-menu>
          </template>
        </a-menu>
        <div class="ContentPageHeader-user">
          <div class="user-component icon" title="用户">
            <a-popover placement="bottom">
              <template slot="content">
                <div style="width: 300px">
                  <div style="text-align: center;margin-bottom: 10px;">
                    <a-avatar :size="64" style="backgroundColor:#87d068;" icon="user"/>
                  </div>
                  <div style="text-align: center;font-weight: bold;font-size: 20px;">
                    {{ account }}
                  </div>
                  <a-card style="width: 250px;text-align: center; margin: 20px auto">
                    <a-row :gutter="[16,16]">
                      <a-col :span="12">
                        <a-statistic title="欧美填表" :value="silverNum">
                          <template #suffix>
                            <a-icon type="like"/>
                          </template>
                        </a-statistic>
                      </a-col>
                      <a-col :span="12">
                        <a-statistic title="东南亚填表" :value="bronzeNum">
                          <template #suffix>
                            <a-icon type="like"/>
                          </template>
                        </a-statistic>
                      </a-col>
                    </a-row>
                    <a-row :gutter="[16,16]">
                      <a-col :span="12">
                        <a-statistic title="签证导出" :value="ironNum">
                          <template #suffix>
                            <a-icon type="like"/>
                          </template>
                        </a-statistic>
                      </a-col>
                    </a-row>
                  </a-card>
                  <div style="text-align: center;font-weight: bold;font-size: 20px;">
                    <a-button @click="handlePassword">修改密码</a-button>
                  </div>
                </div>
              </template>
              <a style="color: white">
                <a-icon type="user" style="font-size: 20px;" @mouseover="handleUser"></a-icon>
              </a>
            </a-popover>
          </div>
          <div class="user-component icon" title="注销">
            <a style="color: white">
              <a-icon type="logout" style="font-size: 20px;" @click="handleLogout"></a-icon>
            </a>
          </div>
        </div>
      </div>
      <UpdatePassword ref="updatePassword"></UpdatePassword>
    </div>
  </section>
</template>

<script>
import UpdatePassword from "@/components/UpdatePassword";
import {HttpMixins} from "@/mixins/http-mixins";

export default {
  name: "Header",
  components: {UpdatePassword},
  mixins: [HttpMixins],
  data() {
    return {
      current: [],
      permissionList: [],
      country: '',
      bronzeNum: '0',
      silverNum: '0',
      ironNum: '0',
      account: localStorage.getItem('username'),
      url: {
        logout: window._CONFIG['domainURL'] + "/auth/logout",
        info: window._CONFIG['domainURL'] + "/user/info",
        updatePassword: window._CONFIG['domainURL'] + "/user/updatePassword",
      }
    }
  },
  created() {
    let country = localStorage.getItem('country');
    if (!country) {
      localStorage.setItem('country', '美国');
      country = '美国';
    }
    this.country = country;
    this.reloadCountry();
  },
  watch: {
    '$route'(to, from) {
      if (to.name !== from.name) {
        this.reload(to.name);
      }
    }
  },
  methods: {
    reloadCountry() {
      let list = JSON.parse(localStorage.getItem('permissionList'));
      this.permissionList = [];
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        if (item.name === '系统管理') {
          this.permissionList.push(item);
        }
        if (item.name === this.country) {
          this.permissionList = this.permissionList.concat(item.children);
        }
      }
    },
    reload(name) {
      this.current = [name];
    },
    handleCountry(value) {
      // if (value === '澳大利亚') {
      //   this.$message.warning("使馆升级，网站更新开发中，耐心等待...");
      // }
      if (value === '加拿大' || value === '新西兰' || value === '法国' || value === '俄罗斯') {
        this.$message.warning("开发中...");
        return;
      }
      localStorage.setItem('country', value);
      this.country = value;
      this.reloadCountry();
    },
    handleLogout() {
      let that = this;
      that.$router.push({path: '/login'})
    },
    handleUser() {
      let that = this;
      const handleSuccess = (res) => {
        if (res) {
          let response = res.data;
          that.bronzeNum = response.bronzeNum;
          that.silverNum = response.silverNum;
          that.ironNum = response.ironNum;
        }
      };

      this.$axios.get(that.url.info, {headers: that.headers})
          .then(handleSuccess)
          .catch((error) => that.catchError(error).then(handleSuccess))
    },
    handlePassword() {
      this.$refs.updatePassword.show();
    }
  },
  mounted() {
    let name = this.$route.name;
    this.reload(name);
  }
}
</script>

<style scoped>

.ant-menu-horizontal > .ant-menu-item > a:hover, .ant-menu-horizontal > .ant-menu-item > a {
  color: white;
}

.ContentPageMenu {
  color: white;
  background: transparent;
  border-bottom: none
}

.submenu-title-wrapper {
  color: white;
}

.ant-menu-horizontal > .ant-menu-item:hover, .ant-menu-horizontal > .ant-menu-submenu:hover, .ant-menu-horizontal > .ant-menu-item-active, .ant-menu-horizontal > .ant-menu-submenu-active, .ant-menu-horizontal > .ant-menu-item-open, .ant-menu-horizontal > .ant-menu-submenu-open, .ant-menu-horizontal > .ant-menu-item-selected, .ant-menu-horizontal > .ant-menu-submenu-selected {
  color: white;
  border-bottom: none;
  background: rgba(0, 0, 0, 0.1);
}

.ant-menu-horizontal > .ant-menu-item, .ant-menu-horizontal > .ant-menu-submenu {
  border-bottom: none;
}

.Header-topNav-inner nav {
  display: flex;
  height: 100%;
}

.u-flex-grow {
  flex-grow: 1;
}

.ContentPageHeader-user {
  display: flex;
  height: 100%;
}

.ContentPageHeader-user .user-component.icon {
  padding-top: 13px;
  width: 50px;
  text-align: center;
}

.ContentPageHeader-user .user-component:hover {
  background: rgba(0, 0, 0, 0.1);
}

.ContentPageHeader {
  color: white;
}

.BasicHeader--default {
  background: #4a90e2;
}

.BasicHeader {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}

.Header-topNav {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.1);
}

.Header-topNav-inner {
  height: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  max-width: 1800px;
  margin-left: auto;
  margin-right: auto;
  padding-right: 15px;
  padding-left: 15px;
}

.BlueOceanLogo, .BlueOceanLogo:hover {
  display: flex;
  color: white;
  text-decoration: none;
  align-items: center;
  font-size: 20px;
  position: relative;
  top: -1px;
  font-weight: bold
}

</style>
